import { forwardRef, useImperativeHandle, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

interface ReCAPTCHAComponentProps {
  onChange: (token: string | null) => void;
}

export interface ReCAPTCHAComponentRef {
  reset: () => void;
}

const ReCAPTCHAComponent = forwardRef<ReCAPTCHAComponentRef, ReCAPTCHAComponentProps>(
  ({ onChange }, ref) => {
    const recaptchaRef = useRef<ReCAPTCHA>(null);

    useImperativeHandle(ref, () => ({
      reset: () => {
        recaptchaRef.current?.reset();
      },
    }));

    if (!RECAPTCHA_SITE_KEY) {
      console.warn('VITE_RECAPTCHA_SITE_KEY não configurada');
      return null;
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={onChange}
        />
      </div>
    );
  }
);

ReCAPTCHAComponent.displayName = 'ReCAPTCHAComponent';

export default ReCAPTCHAComponent;
